import React, { useState } from "react";

import { ContainerForm, ContentForm, TitleForm } from "components/styles";
import { Input, Button } from "./styles";


import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import BackToView from "components/BackToView/BackToView";
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import ToastMessage from "components/ToastMessage/ToastMessage";
import doRequest from "services/helpers";
import { getToken } from "services/auth/tokenAuth";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";


const UploadStudentListForm = () => {
  const [file, setFile] = useState(null);
  const [error, setError] = useState("");
  const [toastMessage, setToastMessage] = useState({ hidden: true, message: "" });

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
    setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!file) {
      setError("Selecciona el archivo de constancias.");
      return;
    }

    const reader = new FileReader();
    reader.onload = async () => {
      const base64File = reader.result.split(",")[1];

      const payload = {
        codigoUsuario: "UsuarioDemo",
        archivoCertificadoAlternativoMasivo: base64File,
      };

      try {
        const [result, err] = await doRequest(
          `/CertificadosAlternativos/CargaMasiva`,
          "POST",
          payload,
          getToken()
        );
        if (!result.ok) {
          throw new Error(err.message);
        }

        setToastMessage({
          hidden: false,
          message: "Archivo de constancias cargado correctamente.",
        });
        setFile(null);
      } catch (err) {
        setError(err.message);
      }
    };

    reader.onerror = () => {
      setError("No pudimos leer el archivo de constancias.");
    };

    reader.readAsDataURL(file);
  };

  return (
    <>
      <ContainerForm>
        <HelmetUTP title="Eventos - Carga masiva de constancias" />
        <BackToView 
                text="Volver a Eventos"
                to={ABSOLUTE_PATHS.EVENT_LIST}/>
        <TitleForm>Carga masiva de constancias</TitleForm>
        <ContentForm>
          <part>
            
          </part>
          <form onSubmit={handleSubmit} style={{ width: "100%", maxWidth: "500px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "15px" }}>
              <Input type="file" accept=".xlsx" onChange={handleFileChange} />
              {error && <ErrorMessage error={true} text={error} />}
              <Button type="submit" style={{ marginTop: "15px" }}>Cargar constancias</Button>
            </div>
          </form>
          </ContentForm>
        
        <ToastMessage {...toastMessage} onClose={() => setToastMessage({ ...toastMessage, hidden: true })} />
      </ContainerForm>
      </>
  );
};

export default UploadStudentListForm;
